import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import './index.css';
import App from './App';
import { getStoredUtms, initUtmsFromUrl } from './utils/utm';
import {
  readPosthogBootstrapFromUrl,
  stripPosthogBootstrapParamsFromUrl,
} from './utils/posthogBootstrapUrl';

const posthogBootstrap = readPosthogBootstrapFromUrl();

posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY!, {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  defaults: '2026-01-30',
  capture_pageview: false,
  ...(posthogBootstrap ? { bootstrap: posthogBootstrap } : {}),
});

initUtmsFromUrl();
const utms = getStoredUtms();
if (Object.keys(utms).length > 0) {
  posthog.register(utms);
}

stripPosthogBootstrapParamsFromUrl();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 